import genererGuid from '@/services/general/genererGuid';
import formatIsoDate from '@/services/general/formatIsoDate';

export const initializeRapprochementsLignesCommande = (commande) => {
  commande.lignesCommande.forEach((ligne) => {
    const reference = genererGuid();
    ligne.rapprochements = commande.rapprochements
      .filter((r) => r.ligneBonReceptionId === ligne.id)
      .map((r) => ({ ...r, referenceRapprochement: reference }));
  });
};

export const gestionRapprochementLigne = (commande, lignesLieux) => {
  commande.lignesCommande.filter((l) => !!l.produitId).forEach((item) => {
    const referenceRapprochement = item.referenceRapprochement || genererGuid();
    item.rapprochements = item.rapprochements || [];
    item.referenceRapprochement = referenceRapprochement;
    const rapprochementsFilteredByLigneBR = item.rapprochements
      .filter((r) => r?.quantite !== 0 || r?.id)
      .map((r) => ({ ...r, referenceRapprochement }));
    const lignesCAARapprocher = lignesLieux
      ?.filter((l) => l.ligneCommande.produitId === item.produitId)
      ?.filter((l) => !rapprochementsFilteredByLigneBR
        .map((r) => r.ligneCommandeLieuLivraisonId).includes(l.id))
      ?.map((l) => ({
        quantite: 0,
        ligneBonReceptionId: item?.id || null,
        ligneCommandeLieuLivraisonId: l.id,
        ligneCommandeLieuLivraison: l,
        referenceRapprochement,
      })) ?? [];
    item.rapprochements = [...rapprochementsFilteredByLigneBR, ...lignesCAARapprocher];
    item.rapprochements.sort((a, b) => {
      const libelleA = a.ligneCommandeLieuLivraison.ligneCommande.libelle;
      const libelleB = b.ligneCommandeLieuLivraison.ligneCommande.libelle;
      if (libelleA < libelleB) return -1;
      if (libelleA > libelleB) return 1;
      return 0;
    });
  });
};

export const getRapprochementsLignesCommande = (commande) => {
  return commande.lignesCommande
    .filter((l) => !!l.rapprochements)
    .flatMap((l) => l.rapprochements)
    .filter((r) => r?.quantite !== 0)
    .map((r) => ({ ...r, dateRapprochement: formatIsoDate(new Date()) }));
};
